import * as React from "react";

import { Content } from "./CrossfitTableSidebarMultilineRow.styles";

interface CrossfitTableSidebarMultilineRowProps {
    children: readonly React.ReactNode[];
}

export function CrossfitTableSidebarMultilineRow(props: CrossfitTableSidebarMultilineRowProps): JSX.Element {
    return (
        <tr>
            <td>
                <Content>{props.children}</Content>
            </td>
        </tr>
    );
}
